/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PatientActivationsverifyPatientActivation model module.
 * @module model/PatientActivationsverifyPatientActivation
 * @version v0.3
 */
export default class PatientActivationsverifyPatientActivation {
  /**
   * Constructs a new <code>PatientActivationsverifyPatientActivation</code>.
   * @alias module:model/PatientActivationsverifyPatientActivation
   * @class
   * @param token {String} Auto-enrollment activation token
   */
  constructor(token) {
    this.token = token;
  }

  /**
   * Constructs a <code>PatientActivationsverifyPatientActivation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientActivationsverifyPatientActivation} obj Optional instance to populate.
   * @return {module:model/PatientActivationsverifyPatientActivation} The populated <code>PatientActivationsverifyPatientActivation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientActivationsverifyPatientActivation();
      if (data.hasOwnProperty('token'))
        obj.token = ApiClient.convertToType(data['token'], 'String');
    }
    return obj;
  }
}

/**
 * Auto-enrollment activation token
 * @member {String} token
 */
PatientActivationsverifyPatientActivation.prototype.token = undefined;
